import { useMemo, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import { FullContainerSpinner } from 'components/ContainerSpinner';
import { useCurrent } from 'features/auth';

interface CustomerRouteGuardProps {
  children: React.ReactNode;
}

export const CustomerRouteGuard = ({ children }: CustomerRouteGuardProps) => {
  const { data, loading } = useCurrent();

  const isCustomerClient = useMemo(() => data?.current?.isCustomerClient ?? false, [data]);
  const isCustomer = !isCustomerClient;

  if (loading) {
    return (
      <Suspense fallback={<FullContainerSpinner />}>
        <FullContainerSpinner />
      </Suspense>
    );
  }

  if (!isCustomer) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
